module.exports = __webpack_public_path__ + "static/media/geogames_flags.e88e04b5.png";